import { PageToken } from './page-token';

class pageTokenSetting {
  constructor(
    public title: string,
    public path: string,
  ) {}
}

export const pageSettings = new Map<PageToken, pageTokenSetting>();
function add(token: PageToken, title: string, path: string) {
  pageSettings.set(token, { title, path });
}

add('login-page', 'Login', '');
add('forgot-password-page', 'Forgot Password', 'forgot-password');
add('forgot-username-page', 'Forgot Username', 'forgot-username');
add('mfa-page', 'Authentication', 'mfa');
add('password-reset-page', 'Password Reset', 'password-reset');
add('account-locked-page', 'Account Locked', 'account-locked');
add('otp-page', 'One-time Code', 'otp');
add('empty-page', 'Empty', 'empty');
add('login-design-page', 'Login design', 'login-design');
add('sso-log-out-page', 'SSO Logout', '');
add(
  'distributed-reports-page',
  'Distributed Reports',
  'external-distributed-reports',
);
add('distributed-reports-landing-page', 'Distributed Reports', '');
add('reports-page', 'Reports', 'reports');
add('reports-landing-page', 'Reports', '');
add('completed-report-page', 'Completed Report', 'completed-report/:requestId');
add(
  'distributed-report-page',
  'Distributed Report',
  'distributed-report/:reportId',
);
add('scheduled-report-page', 'Scheduled Report', 'scheduled-report/:requestId');
add('my-report-page', 'Personalized Report', 'my-report/:requestId');
add('new-report-page', 'New Report', 'new-report');
add('edit-report-page', 'Edit Report', 'edit-report');
add('new-filter-page', 'New Filter', 'edit-filter');
add('edit-filter-page', 'Edit Filter', 'edit-filter/:filterId');
add('pending-report-page', 'Shared Report', 'pending-report/:requestId');
add('edit-schedule-page', 'Edit Schedule', 'edit-schedule');
add('alerts-page', 'Alerts', 'alerts');
add('alerts-landing-page', 'Alerts', '');
add('edit-alert-page', 'New alert', 'edit-alert');
add('dashboards-page', 'Dashboards', 'dashboards');
add('home-page', 'Welcome', '');
add('design-page', 'Design', 'design');
add('todo-page', 'My to-do', 'todo');
add('diary-types-page', 'My to-do', 'diary-types');
add('diary-edit-page', 'Edit Diary', 'diary-edit');
add('my-tasks-page', 'My Tasks', 'my-tasks');
add('task-edit-page', 'Edit Task', 'task-edit');
add('applications-page', 'Applications', 'applications');
add('preferences-page', 'Preferences', 'preferences');
add(
  'communication-preferences-page',
  'Communication Preferences',
  'communication-preferences',
);
add('password-change-page', 'Change Password', 'password-change');
add('downloads-page', 'Downloads', 'downloads');
add('query-page', 'Query', 'query');
add('view-page', 'View', 'view');
add(
  'view/claim/:recordSource/:recordId-page',
  '',
  'view/claim/:recordSource/:recordId',
);
add('claim-summary-page', 'Claim Summary', '');
add('claim-page', 'Claim', 'claim');
add('claimant-page', 'Claimant', 'claimant');
add('legal-page', 'Legal', 'legal');
add('address-book-page', 'Contacts', 'address-book');
add('appeals-page', 'Appeals', 'appeals');
add('my-view-page', 'My view', 'my-view');
add('disability-page', 'Disability', 'disability');
add('general-liability-page', 'General liability', 'general-liability');
add(
  'workers-compensation-page',
  "Workers' compensation",
  'workers-compensation',
);
add('property-page', 'Property', 'property');
add('auto-liability-page', 'Auto liability', 'auto-liability');
add('medical-page', 'Medical', 'medical');
add('notes-page', 'Notes', 'notes');
add('note-edit-page', 'Edit Note', 'note-edit');
add('documents-page', 'Documents', 'documents');
add('correspondence-page', 'Correspondence', 'correspondence');
add('upload-page', 'Upload', 'upload');
add('custom-fields-page', 'Custom fields', 'custom-fields');
add('examiner-diary-page', 'Examiner diary', 'examiner-diary');
add('document-tasks-page', 'To-do', 'document-tasks');
add('document-task-edit-page', 'Task', 'document-task-edit');
add('time-tracking-page', 'Time tracking', 'time-tracking');
add('earnings-page', 'Earnings', 'earnings');
add('accruals-page', 'Accruals', 'accruals');
add('deductions-page', 'Deductions', 'deductions');
add('hr-contacts-page', 'HR contacts', 'hr-contacts');
add('dependents-page', 'Dependents', 'dependents');
add('payroll-page', 'Payroll', 'payroll');
add('employee-detail-page', 'Employee detail', 'employee-detail');
add('job-history-page', 'Job history', 'job-history');
add('benefit-plan-page', 'Benefit plan', 'benefit-plan');
add('overview-page', 'Overview', 'overview');
add('payment-history-page', 'Payment history', 'payment-history');
add('recoveries-page', 'Recoveries', 'recoveries');
add('reserves-page', 'Reserves', 'reserves');
add('reimbursements-page', 'Reimbursements', 'reimbursements');
add('overpayments-page', 'Overpayments', 'overpayments');
add(
  'overpayment-detail/:overpaymentId-page',
  'Overpayment Detail',
  'overpayment-detail/:overpaymentId',
);
add('offsets-page', 'Offsets', 'offsets');
add('invoice-list-page', 'Bill/Invoice', 'invoice-list');
add('invoice-bill/:icn-page', 'Bill/invoice detail', 'invoice-bill/:icn');
add('absence-page', 'Absence', 'absence');
add('leave-calendar-page', 'Leave calendar', 'leave-calendar');
add('eligibility-page', 'Eligibility', 'eligibility');
add('certifications-page', 'Certifications', 'certifications');
add('index-system-page', 'Index system', 'index-system');
add('tender-page', 'Tender', 'tender');
add('plan-summary-page', 'Plan summary', 'plan-summary');
add('job-functions-page', 'Job functions', 'job-functions');
add('interactions-page', 'Interactions', 'interactions');
add('restrictions-page', 'Restrictions', 'restrictions');
add('accommodations-page', 'Accommodations', 'accommodations');
add('milestones-page', 'Milestones', 'milestones');
add('edi-page', 'EDI', 'edi');
add('policy-details-page', 'Policy details', 'policy-details');
add('vendor-referral-page', 'Vendor referrals', 'vendor-referral');
add('case-management-page', 'Case management', 'case-management');
add(
  'case-management-detail/:serviceId-page',
  'Case Management Detail',
  'case-management-detail/:serviceId',
);
add(
  'service-instructions-page',
  'Service instructions',
  'service-instructions',
);
add('medicare-page', 'Medicare', 'medicare');
add('sidekick-summary-page', 'Omni AI summary', 'sidekick-summary');
add('forbidden-page', 'Forbidden', 'forbidden');
add('sso-error-page', 'Login error', 'sso-error');
add('not-found-page', 'Not found', 'not-found');
